import _ from 'lodash';
import { createClient } from '@/shared/api';
import RMA_TICKETS_QUERY from '../queries/rmaTickets';

/**
 * Loads a filtered, size-capped page of RMA tickets for the maintenance list. Runs RMA_TICKETS_QUERY and throws the first GraphQL error message when the RmaTickets field comes back nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 10.
 * @returns The RMA tickets page.
 */
const fetchRmaTickets = async (filter: any, limit = 10) => {
  const client = createClient();
  const result = await client.query({
    query: RMA_TICKETS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = result;
  const { RmaTickets } = data;
  if (_.isNil(RmaTickets) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return RmaTickets;
};

export default fetchRmaTickets;
